import { Box } from "@mui/material";
import { ReactNode } from "react";

interface Props {
  children: ReactNode | ReactNode[];
}

export function EntityInlineActions({ children }: Props) {
  return <Box>{children}</Box>;
}
